import React, { useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "./AuthContext";

const Login = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const { setUser } = useContext(AuthContext);
  const navigate = useNavigate();

  const handleLogin = () => {
    if (username === "admin" && password === "password123") { // Dummy Credentials
      setUser({ username }); // Save user state
      navigate("/edit"); // Redirect to edit page
    } else {
      alert("Invalid credentials");
    }
  };

  return (
    <div className="container">
      <h2>Login</h2>
      <input type="text" placeholder="Username" className="form-control" onChange={(e) => setUsername(e.target.value)} />
      <input type="password" placeholder="Password" className="form-control mt-2" onChange={(e) => setPassword(e.target.value)} />
      <button className="btn btn-primary mt-2" onClick={handleLogin}>Login</button>
    </div>
  );
};

export default Login;